import Konva from 'konva/konva'

const padding = 3
const font = { family: 'Roboto', size: 12 }
const assetFontStyle = 'bold'
const color = 'rgba(0,0,0,0.87)'
const variableMarginBottom = 15

const background = 'White'

export default class TitleLabel extends Konva.Group {
/*
  yOffset = 0
  text = ''

  color = 'rgba(0, 0, 0, 0.87)'
  background = 'white'
  font = { family: 'Roboto', size: 12, style: 'normal' }
  padding = 2
  margin = 15

  constructor(yOffset, text, options) {
    super()

    this.yOffset = yOffset
    this.text = text

    if (options && options.font)
      options.font = Object.assign({}, this.font, options.font)

    if (options)
      Object.assign(this, options)
  }

  render () {
    this.destroyChildren()

    console.log(this.yOffset)
    const text = new Konva.Text({
      x: this.padding,
      y: this.yOffset,
      text: this.text,
      fontFamily: this.font.family,
      fontSize: this.font.size,
      fontStyle: this.font.style,
      fill: this.color
    })

    this.add(text)

    if (this.height) {
      text.setY(this.yOffset + (this.height - this.margin) / 2 - text.getHeight() / 2)
    }

    const background = new Konva.Rect({
      x: 0,
      y: text.getY() - this.padding,
      width: text.getWidth() + 2 * this.padding,
      height: text.getHeight() + 2 * this.padding,
      cornerRadius: 2 * this.padding,
      fill: this.background,
      opacity: 0.7
    })

    this.add(background)
    background.moveToBottom()
  }*/

  constructor ({ height, yOffset, title, asset, options }) {
    super()
    Object.assign(this, { height, yOffset, title, asset })

    if (options)
      Object.assign(this, { background: background }, options)
  }

  render () {
    this.destroyChildren()

    const text = new Konva.Text({
      x: padding,
      y: this.yOffset,
      text: this.title,
      fontFamily: font.family,
      fontSize: font.size,
      fontStyle: this.asset && assetFontStyle,
      fill: color
    })
    this.add(text)
    if (this.height) {
      text.setY(this.yOffset + (this.height - variableMarginBottom) / 2 - text.getHeight() / 2)
    }

    const background = new Konva.Rect({
      x: 0,
      y: text.getY() - padding,
      width: text.getWidth() + 2 * padding,
      height: text.getHeight() + 2 * padding,
      cornerRadius: 2 * padding,
      fill: this.background,
      opacity: 0.7
    })
    this.add(background)
    background.moveToBottom()
  }
}
